import React from "react";
import styles from "./Spinner.module.scss";

type Position = "relative" | "absolute";

interface Props {
  className?: string;
  text?: string;
  position?: Position;
}

const Spinner = ({ className = "", position = "absolute", text }: Props): JSX.Element => (
  <div className={`${styles.container} ${styles[position]} ${className}`.trim()}>
    <div className={`${styles.spinner}`}></div>
    {text && <p className={styles.text}>{text}</p>}
  </div>
);

export default Spinner;
